// extracted by mini-css-extract-plugin
export default {"tiptapEditor":"tiptap-editor__gaYxoJWT"};